import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import demoSlice from './demoSlice';

export const demoActions = demoSlice.actions;

export const increaseCount = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    dispatch(demoActions.increaseCount());
  };
};

export const decreaseCount = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    dispatch(demoActions.decreaseCount());
  };
};

export const updateColor = (color: string): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    dispatch(demoActions.setColor(color));
  };
};

export const clearDemo = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(demoActions.clearDemo());
  };
};
